/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogitem_Newvalue2Inputs */

const id_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai baru`)
};

const ms_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai baharu`)
};

const da_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny værdi`)
};

const de_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Wert`)
};

const en_us2_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New value`)
};

const es_es2_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor nuevo`)
};

const es_mx2_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor nuevo`)
};

const fil_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagong halaga`)
};

const fr_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle valeur`)
};

const it_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo valore`)
};

const hu_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új érték`)
};

const nl_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe waarde`)
};

const no_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny verdi`)
};

const pl_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowa wartość`)
};

const pt_br2_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New value`)
};

const pt_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor novo`)
};

const ro_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valoare nouă`)
};

const fi_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi arvo`)
};

const sv_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nytt värde`)
};

const vi_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị mới`)
};

const tr_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni değer`)
};

const cs_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová hodnota`)
};

const bg_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нова стойност`)
};

const ru_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое значение`)
};

const uk_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нове значення`)
};

const ar_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القيمة الجديدة`)
};

const hi_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया मान`)
};

const th_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค่าใหม่`)
};

const ja_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新値`)
};

const zh_cn2_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New value`)
};

const zh_hant1_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New value`)
};

const ko_components_changelogitem_newvalue2 = /** @type {(inputs: Components_Changelogitem_Newvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New value`)
};

/**
* | output |
* | --- |
* | "New value" |
*
* @param {Components_Changelogitem_Newvalue2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogitem_newvalue2 = /** @type {((inputs?: Components_Changelogitem_Newvalue2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogitem_Newvalue2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogitem_newvalue2(inputs)
	if (locale === "ms") return ms_components_changelogitem_newvalue2(inputs)
	if (locale === "da") return da_components_changelogitem_newvalue2(inputs)
	if (locale === "de") return de_components_changelogitem_newvalue2(inputs)
	if (locale === "en-US") return en_us2_components_changelogitem_newvalue2(inputs)
	if (locale === "es-ES") return es_es2_components_changelogitem_newvalue2(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogitem_newvalue2(inputs)
	if (locale === "fil") return fil_components_changelogitem_newvalue2(inputs)
	if (locale === "fr") return fr_components_changelogitem_newvalue2(inputs)
	if (locale === "it") return it_components_changelogitem_newvalue2(inputs)
	if (locale === "hu") return hu_components_changelogitem_newvalue2(inputs)
	if (locale === "nl") return nl_components_changelogitem_newvalue2(inputs)
	if (locale === "no") return no_components_changelogitem_newvalue2(inputs)
	if (locale === "pl") return pl_components_changelogitem_newvalue2(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogitem_newvalue2(inputs)
	if (locale === "pt") return pt_components_changelogitem_newvalue2(inputs)
	if (locale === "ro") return ro_components_changelogitem_newvalue2(inputs)
	if (locale === "fi") return fi_components_changelogitem_newvalue2(inputs)
	if (locale === "sv") return sv_components_changelogitem_newvalue2(inputs)
	if (locale === "vi") return vi_components_changelogitem_newvalue2(inputs)
	if (locale === "tr") return tr_components_changelogitem_newvalue2(inputs)
	if (locale === "cs") return cs_components_changelogitem_newvalue2(inputs)
	if (locale === "bg") return bg_components_changelogitem_newvalue2(inputs)
	if (locale === "ru") return ru_components_changelogitem_newvalue2(inputs)
	if (locale === "uk") return uk_components_changelogitem_newvalue2(inputs)
	if (locale === "ar") return ar_components_changelogitem_newvalue2(inputs)
	if (locale === "hi") return hi_components_changelogitem_newvalue2(inputs)
	if (locale === "th") return th_components_changelogitem_newvalue2(inputs)
	if (locale === "ja") return ja_components_changelogitem_newvalue2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogitem_newvalue2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogitem_newvalue2(inputs)
	return ko_components_changelogitem_newvalue2(inputs)
});
export { components_changelogitem_newvalue2 as "components.changelogItem.newValue" }